export default "__VITE_ASSET__BPiIzDi4__"